document.addEventListener("DOMContentLoaded", () => {
  if (!window.gsap || !window.ScrollTrigger) return;
  if ((document.documentElement.dataset.animations === "false" || matchMedia("(prefers-reduced-motion: reduce)").matches)) return;
  gsap.registerPlugin(ScrollTrigger);

  // OUR COLLECTIONS
  const collectionSlider = document.querySelector(
    ".featured-collection__slider",
  );

  const collectionTrack = document.querySelector(".featured-collection__track");

  const collectionGroup = document.querySelector(".featured-collection__group");

  if (collectionSlider && collectionTrack && collectionGroup) {
    const collectionAnimation = gsap.to(collectionTrack, {
      x: () => -collectionGroup.offsetWidth,
      duration: 25,
      ease: "none",
      repeat: -1,
    });

    collectionSlider.addEventListener("mouseenter", () => {
      collectionAnimation.pause();
    });

    collectionSlider.addEventListener("mouseleave", () => {
      collectionAnimation.play();
    });
  }
});
